export default __webpack_public_path__ + "static/media/ok-icon.d58c1c01.svg";